var render = function render(){var _vm=this,_c=_vm._self._c;return _c('r-tabs',{staticClass:"journal-main",model:{value:(_vm.activeType),callback:function ($$v) {_vm.activeType=$$v},expression:"activeType"}},_vm._l((_vm.types),function(type){return _c('r-tab',{key:type.id,attrs:{"id":type.id,"name":type.label}},[_c('journal-list',{attrs:{"events":_vm.events}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }